import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Segundos desta sessão de jogo; só conta enquanto `running`.
 * Mede por relógio de parede (`Date.now()`), não por ticks: com a aba em segundo
 * plano o navegador espaça os timers e contar ticks sub-reportaria o tempo.
 */
export function useStopwatch(running: boolean): { elapsed: number; reset: () => void } {
  const [elapsed, setElapsed] = useState(0);
  const accumulatedRef = useRef(0); // ms de trechos anteriores já encerrados
  const startedAtRef = useRef<number | null>(null); // início do trecho em andamento

  const compute = () =>
    Math.floor(
      (accumulatedRef.current +
        (startedAtRef.current === null ? 0 : Date.now() - startedAtRef.current)) /
        1000
    );

  useEffect(() => {
    if (!running) return undefined;
    startedAtRef.current = Date.now();
    const id = window.setInterval(() => setElapsed(compute()), 250);
    return () => {
      window.clearInterval(id);
      if (startedAtRef.current !== null) {
        accumulatedRef.current += Date.now() - startedAtRef.current;
        startedAtRef.current = null;
      }
      setElapsed(compute());
    };
  }, [running]);

  const reset = useCallback(() => {
    accumulatedRef.current = 0;
    if (startedAtRef.current !== null) startedAtRef.current = Date.now();
    setElapsed(0);
  }, []);
  return { elapsed, reset };
}
